import alt from 'components/Dispatcher';
import {CreateToastInterface, Toast} from '@store/toast/Toast.types';
import {ActionsBase, NoMethods} from '@store/@types/alt/Actions';

interface SyncMethods {
  addToast: (toast: Partial<CreateToastInterface> & {message: string}) => void;
  removeToast: (toast: Toast) => void;
  removeAllToasts: (options: {dismissibleOnly: boolean}) => void;
}

class ToastActions extends ActionsBase<NoMethods, SyncMethods>() {
  constructor() {
    super();
    this.generateActions('addToast', 'removeToast', 'removeAllToasts');
  }
}

export default alt.createActions<NoMethods, SyncMethods>(ToastActions);
